const translations = {
    en: {
        events: {
            events: "EVENTS",
            attractions: "ATTRACTIONS",
            no_events_or_attractions: "No events or attractions are available."
        }
    },
    de: {
        events: {
            events: "EREIGNISSE",
            attractions: "ATTRAKTIONEN",
            no_events_or_attractions: "Keine Ereignisse oder Attraktionen sind verfügbar."
        }
    },
    es: {
        events: {
            events: "EVENTOS",
            attractions: "ATRACCIONES",
            no_events_or_attractions: "No hay eventos ni atracciones disponibles."
        }
    },
    fr: {
        events: {
            events: "ÉVÉNEMENTS",
            attractions: "ATTRACTIONS",
            no_events_or_attractions: "Il n'y a pas des événements ou des attractions disponibles."
        }
    },
    it: {
        events: {
            events: "EVENTI",
            attractions: "ATTRAZIONI",
            no_events_or_attractions: "Non sono disponibili eventi o attrazioni."
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/events/Events.js